<template>
  <b-col>
    <p :class="[isAlert ? 'text-danger': '']" class="text-uppercase font-weight-bold  deviceWarningTitle">{{ $t(chartTitle) }}</p>
  </b-col>
</template>

<script>


export default {
  name: "ChartTitle" ,
  components: {},
  props: {
    chartTitle: {type: String},
    isAlert: {
      type: Boolean,
      default: false
    }},
  }
</script>

<style scoped>
  .deviceWarningTitle {
    font-size: 20px
  }
  .dangerText {
    font-size: 16px
  }
  .warningicon {
    border-radius: 5px;

    width: 40px;
  height: 40px;
}
</style>
